export interface TeamCredential {
    id: number;
    credential_key: string;
    credential_name: string;
    credentials: any;
}
